Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CodePen = void 0;
var _react = _interopRequireDefault(require("react"));
var _generalObserver = require("../general-observer");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
var CodePen = function CodePen(_ref) {
  var codePenId = _ref.codePenId,
    _ref$height = _ref.height,
    height = _ref$height === void 0 ? 500 : _ref$height,
    _ref$tabs = _ref.tabs,
    tabs = _ref$tabs === void 0 ? 'result' : _ref$tabs,
    _ref$clickToLoad = _ref.clickToLoad,
    clickToLoad = _ref$clickToLoad === void 0 ? false : _ref$clickToLoad,
    _ref$editable = _ref.editable,
    editable = _ref$editable === void 0 ? false : _ref$editable,
    _ref$theme = _ref.theme,
    theme = _ref$theme === void 0 ? 'default' : _ref$theme;
  return /*#__PURE__*/_react["default"].createElement(_generalObserver.GeneralObserver, {
    height: height
  }, /*#__PURE__*/_react["default"].createElement("iframe", {
    "data-testid": "codepen",
    title: "codepen-".concat(codePenId),
    className: "codepen-mdx-embed",
    height: height,
    style: {
      width: '100%'
    },
    scrolling: "no",
    src: "https://codepen.io/team/codepen/embed".concat(clickToLoad ? '/preview' : '', "/").concat(codePenId, "?height=265&theme-id=").concat(theme, "&default-tab=").concat(tabs).concat(editable ? '&editable=true' : ''),
    frameBorder: "no",
    allowFullScreen: true
  }));
};
exports.CodePen = CodePen;